export const GET_SPRINT_BOOKING_LINK_DETAILS_DATA = "GET_SPRINT_BOOKING_LINK_DETAILS_DATA"